import script from "./PersonNameHighlight.vue?vue&type=script&lang=ts&setup=true"
export * from "./PersonNameHighlight.vue?vue&type=script&lang=ts&setup=true"

import "./PersonNameHighlight.vue?vue&type=style&index=0&id=1275223c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1275223c"]])

export default __exports__